<section class="content">
    <div class="container-fluid">
        <div class="row header">
            <div class="col-md-4">
                <label class="form-label" for="selectedProject">Project</label>
                <select id="selectedProject" name="selectedProject" class="form-control" [(ngModel)]="selectedProject">
                    <option selected="selected" disabled="disabled" [ngValue]="null">--Select the Project--</option>
                    <option *ngFor="let project of projects" [ngValue]="project">{{project.name}}</option>
                </select>
            </div>
            <div class="col-md-4">
                <label for="searchTerm" class="form-label">Search</label>
                <div class="row">
                    <div class="col-8"><input id="searchTerm" name="searchTerm" [(ngModel)]="term" type="text" class="form-control" /></div>
                    <div class="col"><button type="button" class="btn btn-primary" [class.disabled]="selectedProject == null" [disabled]="selectedProject == null" (click)="search()">Search</button></div>
                </div>
            </div>
        </div>
        <div class="main mt-4 h-100">
            <div class="row h-100 flex-fill">
                <div class="col-6">
                    <ag-grid-angular *ngIf="documents.length > 0"
                        class="ag-theme-alpine"
                        [rowData]="documents"
                        [domLayout]="'autoHeight'"
                        [animateRows]="true"
                        [pagination]="true"
                        [columnDefs]="colDefs"
                        [gridOptions]="documentGridOptions">
                    </ag-grid-angular>
                </div>
                <div class="col" *ngIf="projectId && documentId && projectId != '' && documentId != ''">
                    <dexio-document-viewer [projectId]="projectId" [documentId]="documentId"></dexio-document-viewer>
                </div>
            </div>
        </div>
    </div>
</section>
